import { Grid } from '@mui/material';

import { useProductFilters } from './hook';
import { ProductFiltersProps } from './props';

import FieldText from '../../../../components/general/fields/fieldText';
import LoadingButtonGeneral from '../../../../components/general/buttons/loadingButtonGeneral';
import { Checkbox } from '../../../../components/general/fields/checkbox';
import AutocompleteField from '../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../shared/utils/params';

export const ProductFilters = ({ onFilter, loading }: ProductFiltersProps) => {
    const { formik, sfcCaptureUnitNews, sfcCaptureUnit } =
        useProductFilters(onFilter);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
        >
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Código"
                    name="code"
                    size="small"
                    touched={formik.touched.code}
                    errors={formik.errors.code}
                    value={formik.values.code}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <FieldText
                    label="Nombre"
                    name="name"
                    size="small"
                    touched={formik.touched.name}
                    errors={formik.errors.name}
                    value={formik.values.name}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(sfcCaptureUnitNews)}
                    label="Unidad de Captura SFC Nuevo"
                    name="sfcCaptureUnitNew"
                    size="small"
                    disabled={sfcCaptureUnitNews.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcCaptureUnitNew}
                    errors={formik.errors.sfcCaptureUnitNew}
                    value={formik.values.sfcCaptureUnitNew}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('sfcCaptureUnitNew', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <AutocompleteField
                    data={formatParams(sfcCaptureUnit)}
                    label="Unidad de Captura SFC"
                    name="sfcCaptureUnit"
                    size="small"
                    disabled={sfcCaptureUnit.length === 0}
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sfcCaptureUnit}
                    errors={formik.errors.sfcCaptureUnit}
                    value={formik.values.sfcCaptureUnit}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('sfcCaptureUnit', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Aplica Escalamiento"
                    checked={Boolean(formik.values.applyEscalations)}
                    onChange={() => {
                        formik.setFieldValue(
                            'applyEscalations',
                            !formik.values.applyEscalations
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Aplica Pqr"
                    checked={Boolean(formik.values.applyPqr)}
                    onChange={() => {
                        formik.setFieldValue(
                            'applyPqr',
                            !formik.values.applyPqr
                        );
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12} sm={4}>
                <Checkbox
                    label="Activo"
                    checked={Boolean(formik.values.active)}
                    onChange={() => {
                        formik.setFieldValue('active', !formik.values.active);
                    }}
                    onBlur={formik.handleBlur}
                />
            </Grid>
            <Grid item xs={12}>
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Buscar"
                    sx={{ mr: 1 }}
                    onClick={formik.submitForm}
                />
                <LoadingButtonGeneral
                    disabled={loading}
                    title="Limpiar"
                    variant="outlined"
                    onClick={formik.resetForm}
                />
            </Grid>
        </Grid>
    );
};
